/**
 * ProjectsEmptyState Component
 * Displayed when no projects exist
 */

import { FolderGit2, Plus, Rocket } from 'lucide-react';

interface ProjectsEmptyStateProps {
  onCreateClick: () => void;
}

export function ProjectsEmptyState({ onCreateClick }: ProjectsEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {/* Icon */}
      <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-coral-100 to-coral-50 flex items-center justify-center mb-6">
        <FolderGit2 size={36} className="text-coral-500" />
      </div>

      {/* Title */}
      <h3 className="text-xl font-semibold text-neutral-900 mb-2">
        No projects yet
      </h3>

      {/* Description */}
      <p className="text-neutral-600 max-w-sm mb-8">
        Projects help you organize your work. Create your first project to get started with Martha.
      </p>

      {/* Actions */}
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={onCreateClick}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-coral-500 hover:bg-coral-600 text-white rounded-lg font-medium transition-colors"
        >
          <Plus size={18} />
          Create First Project
        </button>
      </div>

      {/* Tips */}
      <div className="mt-12 max-w-md">
        <h4 className="text-sm font-medium text-neutral-700 mb-3 flex items-center gap-2 justify-center">
          <Rocket size={16} className="text-coral-500" />
          Quick Tips
        </h4>
        <ul className="text-sm text-neutral-600 space-y-2 text-left">
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 rounded-full bg-coral-100 text-coral-600 flex items-center justify-center text-xs font-medium shrink-0 mt-0.5">1</span>
            <span>Each project represents a git repository or codebase</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 rounded-full bg-coral-100 text-coral-600 flex items-center justify-center text-xs font-medium shrink-0 mt-0.5">2</span>
            <span>Projects can be services, applications, or libraries</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 rounded-full bg-coral-100 text-coral-600 flex items-center justify-center text-xs font-medium shrink-0 mt-0.5">3</span>
            <span>Link worktrees and issues to projects for better organization</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
